const ReviewedThesis = {
  queryList: [
    {
      name: 'titleCn',
      label: '论文题目',
      component: 'input'
    },
    {
      name: 'researchAera',
      label: '研究方向',
      component: 'input'
    },
    {
      name: 'firstSubjectCode',
      label: '一级学科',
      component: 'select',
      request: {
        method: 'post',
        addr: '/conf/confFirstSubject/all',
        data: {},
        format: {
          value: 'code',
          label: 'name'
        }
      }
    }
  ],
  urlMap: {
    'select': {
      url: '/exp/expReviewInfo/queryReviewList',
      data: {
        reviewStatus: 2
      }
    }
  },
  operList: [// 操作列表
  ],
  titles: [
    {
      name: 'sendTypeName',
      label: '送审方式'
    },
    {
      name: 'firstSubjectName',
      label: '一级学科'
    },
    {
      name: 'secondSubjectName',
      label: '二级学科'
    },
    {
      name: 'researchAera',
      width: 150,
      label: '论文涉及的研究方向'
    },
    {
      name: 'titleCn',
      label: '论文题目'
    },
    {
      name: 'titleEn',
      label: '论文英文题目'
    },
    {
      name: 'reviewEndTime',
      label: '论文评阅截止时间'
    },
    {
      name: 'reviewTime',
      label: '提交时间'
    },
    {
      name: 'operation',
      label: '操作',
      actionList: [
        {
          label: '详情',
          name: 'detail',
          kind: 'primary', // error
          type: 'router', // request, router, dialog, func
          addr: '/shell/custom/thesisManage/reviewedThesis?id={reviewCode}&degreeType={degreeType}&unitCode={unitCode}'
        }
      ]
    }
  ]
}
export default ReviewedThesis



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/thesisManage/reviewedThesis.js